module.exports = __webpack_public_path__ + "img/flat-screen-tv-1571458.458ce2ec.jpg";